import styled, { css } from 'styled-components'

export const Container = styled.div<{ $borderless?: boolean; $gap: number }>`
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);

  ${({ $borderless }) =>
    !$borderless &&
    css`
      border: 1px solid var(--border-secondary);
    `}

  ${({ $gap }) =>
    $gap &&
    css`
      gap: ${$gap}px;
    `}
`
